import React, { useEffect } from 'react';
import {
  Loadable,
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '../../design-system';
import { Button, Flex, Box, Text, Column, Field } from '../../design-system';
import { useData } from '../../helpers/data-loader';
import {
  errorMsg,
  dateValidate,
  addYearToDate,
  roundDownToWeekday,
} from '../../helpers/utils';
import ModalForm from '../../components/ModalForm';
interface RenewalModalProps {
  open: boolean;
  toggleModal: () => void;
  handleRenewal: (values: any) => void;
  projectId: any;
}

const RenewalModal = ({
  open,
  toggleModal,
  handleRenewal,
  projectId,
}: RenewalModalProps) => {
  const [project, fetchProjectData, projectLoading] = useData(
    `/project/${projectId}`,
    {
      errorMsg: errorMsg('the project'),
    },
  );

  useEffect(() => {
    fetchProjectData();
  }, [fetchProjectData, open]);

  const canRenew =
    project?.status === 'Awarded' ? !!project?.amount_awarded : true;

  return (
    <ModalForm
      title="Renew Project"
      isOpen={open}
      fieldWidth={200}
      modalWidth={350}
      onSubmit={handleRenewal}
      oneColumn={true}
      onClose={toggleModal}
      initialValues={{
        deadline: roundDownToWeekday(addYearToDate(project.deadline)),
      }}
      fields={[
        {
          name: 'deadline',
          label: 'New Deadline',
          type: 'Date',
          validate: dateValidate,
        },
      ]}
    ></ModalForm>

    /*   <Modal show={open} onClose={toggleModal}>
        <ModalHeader>
          <Text fontSize="1.2rem" fontWeight={600}>
            Renew Project
          </Text>
        </ModalHeader>
        <ModalContent>
          <Loadable loading={projectLoading}>
            <Box p={1} style={{ fontSize: '1.1rem' }} maxWidth={400}>
              {canRenew
                ? 'Are you sure you want to renew this project? You can only do this once.'
                : "You must set an Award Amount before renewing projects with the 'Awarded' status."}
            </Box>
          </Loadable>
        </ModalContent>
        <ModalFooter>
          <Flex justifyContent="flex-end">
            <Button
              aria-label="Cancel"
              type="button"
              onClick={toggleModal}
              variant="grey"
            >
              Cancel
            </Button>
            {canRenew && (
              <Box ml={3}>
                <Button
                  aria-label="Confirm Renewal"
                  type="button"
                  onClick={handleRenewal}
                >
                  Renew
                </Button>
              </Box>
            )}
          </Flex>
        </ModalFooter>
      </Modal> */
  );
};

export default RenewalModal;
